import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import ServicesTabs from "./ServicesTabs";
import ServicesContent from "./ServicesContent";

const ServicesSection = () => {
  const [activeTab, setActiveTab] = useState("services");

  return (
    <section className="services-tabs">
      <div className="container">
        <Row>
          <Col lg={3}>
            <ServicesTabs activeTab={activeTab} setActiveTab={setActiveTab} />
          </Col>
          <Col lg={9}>
            <ServicesContent activeTab={activeTab} />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ServicesSection;
